module.exports = __webpack_public_path__ + "static/media/reminder-notes.6311d975.svg";